import { PropsWithChildren } from "react";

import "pages/common.scss";

type IProps = PropsWithChildren<{
  className: string;
}>;

export const WidePage = (props: IProps): JSX.Element => {
  const className = `${props.className} page wide`;

  return (
    <div className={className}>
      {props.children}
    </div>
  );
};
